var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cmd-toolbar md-colors=\"$ctrl.colors()\" ng-class=\"{&quot;md-whiteframe-3dp&quot;: $ctrl.EyeCatcherService.percent === 100}\"\u003E\u003Cdiv class=\"md-toolbar-tools\" ng-transclude ng-class=\"{&quot;{{::$ctrl.css.invisible}}&quot;: $ctrl.EyeCatcherService.percent &lt; 95}\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-toolbar\u003E";;return pug_html;};
module.exports = template;


// WEBPACK FOOTER //
// ./app/shared/components/toolbar/toolbar.template.pug